module.exports = __webpack_public_path__ + "static/media/syun_active4adc2f50571ac2980b2b145e9c41ca97.webp";